module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/partials/pagination/pagination.component.scss
// module id = ./src/app/components/partials/pagination/pagination.component.scss
// module chunks = main